import { Email, Facebook, Instagram, Pinterest } from '@mui/icons-material';
import { Box, Container, Link, Modal, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React, { useState } from 'react';

function Footer() {
  const [contactOpen, setContactOpen] = useState(false);

  const handleContactOpen = () => setContactOpen(true);
  const handleContactClose = () => setContactOpen(false);


  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'primary.main',
        color: 'white',
        py: 4,
        mt: 'auto',
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="lg">
        <Grid container alignItems="start" justifyContent="space-between">
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" gutterBottom>
              KBros Leather
            </Typography>
            <Typography variant="body2">
              Crafted with care, every piece tells a story of quality and timeless design.
            </Typography>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" gutterBottom data-testid={'footer-quicklinks'}>
              Quick Links
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={4}>
                <Link
                  href="/"
                  underline="hover"
                  sx={{ color: 'white', display: 'block', mb: 1 }}
                  data-testid="footer-home-link"
                >
                  Home
                </Link>
                <Link
                  href="/products"
                  underline="hover"
                  sx={{ color: 'white', display: 'block', mb: 1 }}
                  data-testid="footer-products-link"
                >
                  Products
                </Link>
                <Link
                  href="/gallery"
                  underline="hover"
                  sx={{ color: 'white', display: 'block', mb: 1 }}
                  data-testid="footer-gallery-link"
                >
                  Gallery
                </Link>
              </Grid>
              <Grid item xs={4}>
                <Link
                  href="/reviews"
                  underline="hover"
                  sx={{ color: 'white', display: 'block', mb: 1 }}
                  data-testid="footer-reviews-link"
                >
                  Reviews
                </Link>
                <Link
                  href="/about"
                  underline="hover"
                  sx={{ color: 'white', display: 'block', mb: 1 }}
                  data-testid="footer-about-link"
                >
                  About Us
                </Link>
                <Link
                  href="/faq"
                  underline="hover"
                  sx={{ color: 'white', display: 'block', mb: 1 }}
                  data-testid="footer-faq-link"
                >
                  FAQ
                </Link>
              </Grid>
              <Grid item xs={4}>
                <Link
                  href="/configurator"
                  underline="hover"
                  sx={{ color: 'white', display: 'block', mb: 1 }}
                  data-testid="footer-design-link"
                >
                  Wallet Designer
                </Link>
                <Link
                  href="https://kbrosleather.etsy.com"
                  target="_blank"
                  underline="hover"
                  sx={{ color: 'white', display: 'block', mb: 1 }}
                  data-testid="footer-shop-link"
                >
                  Shop
                </Link>
                <Link
                  href="/events"
                  underline="hover"
                  sx={{ color: 'white', display: 'block', mb: 1 }}
                  data-testid="footer-events-link"
                >
                  Events
                </Link>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" gutterBottom>
              Follow Us
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Link href="https://facebook.com" target="_blank" rel="noopener" data-testid="footer-facebook-link">
                <Facebook sx={{ color: 'white' }} />
              </Link>
              <Link href="https://instagram.com" target="_blank" rel="noopener" data-testid="footer-instagram-link">
                <Instagram sx={{ color: 'white' }} />
              </Link>
              <Link href="https://pinterest.com" target="_blank" rel="noopener" data-testid="footer-pinterest-link">
                <Pinterest sx={{ color: 'white' }} />
              </Link>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h6" gutterBottom>
              Contact Us
            </Typography>
            <Box sx={{ display: 'flex', gap: 2 }}>
              <Link onClick={handleContactOpen} data-testid="footer-contact-link">
                <Email sx={{ color: 'white' }} />
              </Link>
            </Box>
          </Grid>
        </Grid>

        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            &copy; {new Date().getFullYear()} KBros Leather. All rights reserved.
          </Typography>
        </Box>

        <Modal
          open={contactOpen}
          onClose={handleContactClose}
          aria-labelledby="contact-modal-title"
          aria-describedby="contact-modal-description"
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              bgcolor: 'background.paper',
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
            }}
          >
            <Typography id="contact-modal-title" variant="h6" component="h2">
              Contact Us
            </Typography>
            <Typography id="contact-modal-description" sx={{ mt: 2 }}>
              For inquiries, email us at <Link href="mailto:jeremy@kbrosleather.com">jeremy@kbrosleather.com</Link>
            </Typography>
          </Box>
        </Modal>
      </Container>
    </Box>
  );
}

export default Footer;
